import Vue from 'vue';
import Component from 'vue-class-component';

import HintMessage from 'components/HintMessage';
import { useBoxCatalogViewStore } from 'stores/boxCatalogView.store.js';
import moment from 'common/deps/moment';

@Component({
  props: {
    activity: {
      type: Object,
      required: true,
    },
    clientDataStep: {
      type: Object,
      required: true,
      description: 'data from previus step',
    },
    selectDateStep: {
      type: Object,
      required: true,
      description: 'data from first step',
    },
    reservationConfig: {
      type: Object,
      required: true,
      description: 'used to show cancellation policy',
    },
    isComboActivity: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    HintMessage,
  },
  setup() {
    const catalogViewStore = useBoxCatalogViewStore();
    return {
      catalogViewStore,
    };
  },
})
export default class CatalogAutomaticReservationCompletedStepComponent extends Vue {
  get clientFullName() {
    return `${this.clientDataStep.firstName} ${this.clientDataStep.lastName}`;
  }

  get calendarLink() {
    const { date, appointment } = this.selectDateStep;

    let date_ = moment(`${date.date}T${appointment.time}`).format(
      'DD/MM/YYYY - H:mm a',
    );

    let dateFormated = moment(`${date.date}T${appointment.time}`).format(
      'DD/MM/YYYY',
    );

    const url = this.generateCalendarUrl();

    if (appointment.end_time) {
      let date_init = moment(appointment.time, 'HH:mm:ss').format('H:mm a');

      const date_range = moment(appointment.end_time, 'HH:mm:ss').format(
        'H:mm a',
      );
      date_ = `${dateFormated} - llegada entre las ${date_init} y las ${date_range}`;
    }

    return `<a
      target="_blank"
      href="${url}"
      class="calendarLink bb-bold"
    >${date_} </a>`;
  }

  generateCalendarUrl() {
    const url = new URL('https://www.google.com/calendar/render');
    const params = new URLSearchParams(url.search);

    const dates = this.resolveCalendarDates();
    params.set('action', 'TEMPLATE');
    params.set('text', this.activity.name);
    params.set('details', this.activity.short_description);
    params.set('location', this.selectDateStep.location.address);
    params.set('dates', dates);

    url.search = params;
    return url.toString();
  }

  resolveCalendarDates() {
    const fromDate = new Date(
      `${this.selectDateStep.date.date}T${this.selectDateStep.appointment.time}`,
    );
    const toDate = new Date(fromDate);
    toDate.setTime(toDate.getTime() + 1 * 60 * 60 * 1000); // Adds one hour
    const fromDateFormatted = this.formatDateForCalendarUrl(
      fromDate.toISOString(),
    );
    const toDateFormatted = this.formatDateForCalendarUrl(toDate.toISOString());
    return `${fromDateFormatted}/${toDateFormatted}`;
  }

  redirectToAccountGifts() {
    // If the user closes the modal, we redirect to accountGifts view.
    // Vue router has the problem that it does not refresh the page when we navigate to a previously visited route, and we see an old version of it.
    // I was looking for a solution to the problem and found this: https://github.com/vuejs/vue-router/issues/311#issuecomment-497182264
    this.$router.replace({ name: 'accountGifts' }, () => {
      this.$router.go(0);
    });
  }

  beforeDestroy() {
    if (this.isComboActivity) {
      this.$router.go(0); // If is comboactivity we need to refresh the page
    } else if (!this.catalogViewStore.isATT) {
      this.redirectToAccountGifts();
    }
  }

  closeModal() {
    this.$emit('closeModal');
  }

  /**
   *
   * @param {String} date formatted in ISOString
   */
  formatDateForCalendarUrl(date) {
    return date.replaceAll(/(\.|-|:)+/g, '');
  }
}
